<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import SettingsSection from 'dashboard/components/SettingsSection.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    LoadingState,
    SettingsSection,
    NextButton,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedCustomAttributeId: null,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      contactAttributes: 'attributes/getContactAttributes',
    }),

    listTypeContactAttributes() {
      return this.contactAttributes.filter(attr =>
        ['crm'].includes(attr.attributeDisplayType)
      );
    },

    currentCustomAttribute() {
      return this.inbox.custom_attribute_definition_id || null;
    },
  },

  watch: {
    currentCustomAttribute: {
      handler(newVal) {
        this.selectedCustomAttributeId = newVal;
      },
      immediate: true,
    },
  },

  mounted() {
    this.$store.dispatch('attributes/get');
    this.selectedCustomAttributeId = this.currentCustomAttribute;
  },

  methods: {
    async updateCustomAttribute() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          custom_attribute_definition_id:
            this.selectedCustomAttributeId || null,
          channel: {},
        };

        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert(this.$t('INBOX_MGMT.CUSTOM_ATTRIBUTE.SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(
          error?.message || this.$t('INBOX_MGMT.CUSTOM_ATTRIBUTE.ERROR_MESSAGE')
        );
      }
    },

    async disconnectCustomAttribute() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          custom_attribute_definition_id: null,
          channel: {},
        };

        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.selectedCustomAttributeId = null;
        useAlert(
          this.$t('INBOX_MGMT.CUSTOM_ATTRIBUTE.DISCONNECTED_SUCCESS_MESSAGE')
        );
      } catch (error) {
        useAlert(
          error?.message ||
            this.$t('INBOX_MGMT.CUSTOM_ATTRIBUTE.DISCONNECTED_ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="mx-8">
    <LoadingState v-if="uiFlags.isFetching" />
    <form
      v-else
      class="flex flex-wrap mx-0"
      @submit.prevent="updateCustomAttribute"
    >
      <SettingsSection
        :title="$t('INBOX_MGMT.CUSTOM_ATTRIBUTE.TITLE')"
        :sub-title="$t('INBOX_MGMT.CUSTOM_ATTRIBUTE.DESC')"
      >
        <div>
          <label>
            {{ $t('INBOX_MGMT.CUSTOM_ATTRIBUTE.SELECT_LABEL') }}
            <select v-model="selectedCustomAttributeId">
              <option :value="null">
                {{ $t('INBOX_MGMT.CUSTOM_ATTRIBUTE.SELECT_PLACEHOLDER') }}
              </option>
              <option
                v-for="attribute in listTypeContactAttributes"
                :key="attribute.id"
                :value="attribute.id"
              >
                {{ attribute.attributeDisplayName }}
              </option>
            </select>
          </label>

          <div class="button-container space-x-2">
            <NextButton
              type="submit"
              :label="$t('INBOX_MGMT.CUSTOM_ATTRIBUTE.SUBMIT')"
              :is-loading="uiFlags.isUpdating"
            />
            <NextButton
              type="button"
              :disabled="!selectedCustomAttributeId"
              :is-loading="uiFlags.isUpdating"
              faded
              ruby
              @click="disconnectCustomAttribute"
            >
              {{ $t('INBOX_MGMT.CUSTOM_ATTRIBUTE.DISCONNECT') }}
            </NextButton>
          </div>
        </div>
      </SettingsSection>
    </form>
  </div>
</template>
